var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserLog = function SvgUserLog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OutLine",
    viewBox: "0 0 512 512",
    width: "512px",
    height: "512px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.657,18.343A8,8,0,0,0,344,16H120A56.063,56.063,0,0,0,64,72V440a56.063,56.063,0,0,0,56,56H392a56.063,56.063,0,0,0,56-56V120a8,8,0,0,0-2.343-5.657ZM352,43.313,420.687,112H392a40.045,40.045,0,0,1-40-40ZM120,32H336V72a56.063,56.063,0,0,0,56,56h40V352H80V72A40.045,40.045,0,0,1,120,32ZM392,480H120a40.045,40.045,0,0,1-40-40V368H432v72A40.045,40.045,0,0,1,392,480Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,448H168V392a8,8,0,0,0-16,0v64a8,8,0,0,0,8,8h32a8,8,0,0,0,0-16Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,384c-17.645,0-32,17.944-32,40s14.355,40,32,40,32-17.944,32-40S265.645,384,248,384Zm0,64c-8.673,0-16-10.99-16-24s7.327-24,16-24,16,10.99,16,24S256.673,448,248,448Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,416H336a8,8,0,0,0,0,16h7.049c-2.252,9.217-8.236,16-15.049,16-8.673,0-16-10.99-16-24s7.327-24,16-24a10.675,10.675,0,0,1,4.588,1.058,8,8,0,0,0,6.824-14.473A26.587,26.587,0,0,0,328,384c-17.645,0-32,17.944-32,40s14.355,40,32,40,32-17.944,32-40A8,8,0,0,0,352,416Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.247,235.177l46.131,54.2a32.122,32.122,0,0,0,4.073,4.994,32,32,0,1,0,45.256-45.256,32.226,32.226,0,0,0-4.994-4.073l-54.2-46.131a63.8,63.8,0,0,0-14.35-68.589h0a64.381,64.381,0,0,0-75.7-11.043,8,8,0,0,0-1.85,12.694L212.6,152.945a8,8,0,0,1-11.313,11.313l-20.978-20.979a8,8,0,0,0-12.694,1.85,64.009,64.009,0,0,0,79.633,90.048Zm-69.685-72.016,12.41,12.411a24,24,0,0,0,33.941-33.941L211.5,129.221a48.364,48.364,0,0,1,46.352,12.409,47.859,47.859,0,0,1,8.785,55.826,8,8,0,0,0,1.933,9.74l59.165,50.362a8.049,8.049,0,0,0,.9.662,16,16,0,1,1-22.074,22.074,8.057,8.057,0,0,0-.663-.9l-50.361-59.165a8,8,0,0,0-9.74-1.933,47.857,47.857,0,0,1-55.825-8.785A48.353,48.353,0,0,1,177.562,163.161Z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserLog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-log.7d6bceae.svg";
export { ForwardRef as ReactComponent };